
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import EndorsementStatusBadge from "@/features/endorsements/components/EndorsementStatusBadge.vue";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {EndorsementLightViewModel} from "@/api-client";
    import {formatDate} from "@/formatting/dateFormatter";
    import translateEndorsementStatus from "@/features/endorsements/components/EndorsementStatusTranslator";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import ClientsidePagingSelector from "@/components/ClientsidePagingSelector.vue";

    @Component({
        components: {
            EndorsementStatusBadge,
            TableEmptySlot,
            ClientsidePagingSelector
        }
    })
    export default class EndorsementsTable extends Vue {
        @Prop({ required: true})
        endorsements!: EndorsementLightViewModel[];
        @Prop({ default: false})
        withPagination!: boolean;

        paging = new ClientsidePaging();

        navigateToDetails(endorsement: EndorsementLightViewModel) {
            this.$router.push({ name: 'endorsement-details', params: { id: endorsement.id } });
        }

        fields = [
            { key: 'number', label: this.$ls.Global_Label_DocumentNumber, sortable: true, thClass: 'w-15'},
            { key: 'certificateTypeName', label: this.$ls.Global_Label_Certificate, sortable: true, tdClass: 'certificate-name', thClass: 'w-35'},
            { key: 'issuedOn', label: this.$ls.Global_Label_IssueDateShort, sortable: true,
                formatter: (value: any, key: any, item: EndorsementLightViewModel) => formatDate(item.issuedOn) },
            { key: 'validUntil', label: this.$ls.Global_Label_ValidUntil, sortable: true,
                formatter: (value: any, key: any, item: EndorsementLightViewModel) => formatDate(item.validUntil) },
            { key: 'status', label: this.$ls.Global_Label_DocumentState, sortable: true, sortByFormatted: true, thClass: 'w-10',
                formatter: (value: any, key: any, item: EndorsementLightViewModel) => translateEndorsementStatus(item.status) },
            { key: 'linkIcon', label: '', sortable: false, thClass: 'w-5', tdClass: 'table-actions' }
        ];

    }
